import { getUserLocale } from '~/utils/getUserLocale';
import { renderErrorMessageContent } from './renderErrorMessageContent';

const errorMessageTitleCS = 'Ve vyhledávání došlo k chybě.';
const errorMessageContentCS = `Vyhledávání zavřete a zkuste ho spustit znovu. Pokud problém přetrvává, napište nám na <a href="mailto:info@searchready.cz" style="text-decoration: underline;">info@searchready.cz.</a>`;
const errorMessageTitleEN = 'An error occurred during the search.';
const errorMessageContentEN = `Close the search and try to start it again. If the problem persists, please contact us at <a href="mailto:info@searchready.cz" style="text-decoration: underline;">info@searchready.cz.</a>`;

const errorMessageTitle = getUserLocale() === 'cs' ? errorMessageTitleCS : errorMessageTitleEN;
const errorMessageContent = getUserLocale() === 'cs' ? errorMessageContentCS : errorMessageContentEN;

export const ResultsErrorMessage: React.FC = () => {
    return (
        <div
            className="sr-error-container"
            style={{
                width: '100%',
                marginBlock: '30px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <div
                id="sr-error-message-box"
                style={{
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    backgroundColor: '#fbebad',
                    boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.2)',
                    color: '#000',
                    fontSize: '1rem',
                    padding: '20px',
                }}
            >
                <div
                    dangerouslySetInnerHTML={{
                        __html: renderErrorMessageContent(errorMessageTitle, errorMessageContent),
                    }}
                ></div>
            </div>
        </div>
    );
};
